import { render } from "./FieldGroupForm.vue?vue&type=template&id=dbb2324e&ts=true"
import script from "./FieldGroupForm.vue?vue&type=script&lang=ts"
export * from "./FieldGroupForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__